import createCache from "@emotion/cache";
// Create emotion cache
export const emotionCache = createCache({
  key: "exec-app",
  prepend: true, // This will insert styles at the beginning of <head>
});
